/**
 * 대리 로그인 탭 — 토큰은 **이 탭의 sessionStorage 에만** 있다 (selfad D128 방식, 260917-realm-sessions-impersonation).
 *
 * 운영자 탭이 window.open 직전에 써 두면 새 탭이 sessionStorage 사본을 받고, 운영자 탭은 곧바로 지운다.
 * 토큰이 URL·방문 기록에 남지 않고, 쿠키가 아니라서 운영자 로그인도 같은 브라우저의 고객 로그인도 바뀌지 않는다.
 * ★ noopener 를 붙이면 사본이 복사되지 않는다.
 */
const KEY = 'livegpt.impersonation';

export interface Impersonation {
  token: string;
  targetEmail: string;
  adminEmail: string;
}

function read(): Impersonation | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<Impersonation>;
    return typeof v.token === 'string' && typeof v.targetEmail === 'string' && typeof v.adminEmail === 'string'
      ? { token: v.token, targetEmail: v.targetEmail, adminEmail: v.adminEmail }
      : null;
  } catch {
    return null; // 프라이빗 창에서는 접근 자체가 던진다
  }
}

/** 모듈을 처음 읽을 때 한 번 — 탭의 신원은 탭이 사는 동안 바뀌지 않는다 */
const current = read();
// 대리 탭이 운영자 탭을 스크립트로 건드리지 못하게 연결을 끊는다
if (current && window.opener) window.opener = null;

export function impersonation(): Impersonation | null {
  return current;
}

/** 새 탭을 대상 계정의 사용자 화면(/app)으로 연다. 팝업이 막히면 false */
export function openImpersonationTab(input: Impersonation): boolean {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(input));
  } catch {
    return false;
  }
  const tab = window.open('/app', '_blank');
  forgetImpersonation();
  return tab !== null;
}

export function forgetImpersonation(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* 무시 */
  }
}
